import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { RegisterRequest, RegisterSucceed } from '../models';
import { ApiBaseService } from '../crud.service';

@Injectable()
export class RegisterService extends ApiBaseService {
    constructor(protected apiHttp: HttpClient) {
        super(apiHttp);
    }

    registerAccount(body: RegisterRequest): Observable<RegisterSucceed> {
        body.address_country = body.address_country.toUpperCase();
        const path = '/register';
        return this.apiHttp
            .post('/register', {
                data: body,
            })
            .pipe(map((res: any) => res && res.data));
    }

    resendVerify(userId: string): Observable<any> {
        return this.apiHttp
            .get(`/resend_verify/${userId}`)
            .pipe(map((res: any) => res && res.data));
    }
}
